import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  paragraph: {
    whiteSpace: 'pre-line',
    margin: 0,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1) / 2,
    fontWeight: 500
  },
  award: {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.secondary.main,
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  awardTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 400
  },
  finalist: {
    marginTop: theme.spacing(3),
  },
  name: {
    marginBottom: theme.spacing(1) / 2,
  },
  credentials: {
    marginBottom: theme.spacing(1) / 2,
  },
  location: {
    marginBottom: theme.spacing(1) / 2,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    fontWeight: 300,
    lineHeight: 1.6,
  },
  outer: {
    maxWidth: '96px',
  },
  portrait: {
    paddingBottom: '100%',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundColor: '#ddd'
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  paper: {
    marginTop: theme.spacing(3),
    paddingBottom: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundColor: '#ddd'
  }
}));

const Finalist = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.finalist}>
      <Grid container direction="row" alignItems="flex-start" spacing={3}>
        <Grid item xs={4}>
          <div className={classes.outer}><div className={classes.portrait} style={{ backgroundImage: `url('${props.config.imageUrl}')` }}></div></div>
        </Grid>
        <Grid item xs={8}>
          <h6 className={classes.location}>{props.config.location}</h6>
          <h4 className={classes.name}>{props.config.name}</h4>
          <h5 className={classes.credentials}>{props.config.credentials}</h5>
        </Grid>
      </Grid>
      <p className={classes.paragraph}>{props.config.description}</p>
    </div>
  );
}

const Award = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.award}>
      <h3 className={classes.awardTitle} >{props.config.title}</h3>
      {props.config.description &&
        <div><p className={classes.paragraph}>{props.config.description}</p></div>
      }
      <Grid container direction="row" alignItems="flex-start" spacing={6}>
        {props.config.finalists && props.config.finalists.map((finalist, index) => (
          <Grid item md={4} sm={6} xs={12} key={index}>
            <Finalist config={finalist} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

const Award2 = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.award}>
      <h3 className={classes.awardTitle} >{props.config.title}</h3>
      <Grid container direction="row" alignItems="flex-start" spacing={3}>
        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper} style={{backgroundImage: `url('${props.config.imageUrl}')`}}></Paper>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div><p className={classes.paragraph}>{props.config.description}</p></div>
        </Grid>
      </Grid>
    </div>
  );
}

export default (props) => {
  const classes = useStyles();
  return (
    <>
      <h2 className={classes.title}>{props.config.title}</h2>
      <h3 className={classes.subtitle}>{props.config.subtitle}</h3>
      <p className={classes.paragraph}>{props.config.description}</p>
      { props.config.awards && props.config.awards.filter((award) => award.finalists && award.finalists.length > 0).map((award, index) => (
        <Award config={award} key={index} />
      ))}
      <Grid container direction="row" alignItems="flex-start" spacing={6}>
        {props.config.awards && props.config.awards.filter((award) => !award.finalists && award.description.length > 0).map((award, index) => (
          <Grid item xs={12} sm={12} md={6} key={index}>
            <Award2 config={award} />
          </Grid>
        ))}
      </Grid>

    </>
  );
}